import gql from "graphql-tag";

const offerSchema = `
productType
product {
  id
  handle
  image
  title
  variant_id
  price
  description
  description_quill
  originalDescription
  images{
    id
    src
  }
  variants {
    id
    title
    price
    image
  }
  options {
    id
    name
    position
    values
  }
}
blocks {
    banner {
      isActive
      background_color
      heading
      heading_quill
      description
      description_quill
      timer_value
      timer_end_action
    }
    product_config {
      image_border
      price
      price_quill
      show_quantity
      show_variants
      show_saving
      show_shipping
      show_taxes
      extra_text
      extra_text_quill
      header
      header_quill
    }
    extra_blocks {
      isActive
      alignement
      header
      header_quill
      description
      description_quill
      withImage
      image
    }
    checkout_button {
      isActive
      showTotal
    }
}
discount_type
discount_value
`
const GET_SINGLE_CAMPAIGN = gql`
  query GetSingleCampaign($id: ID!) {
    campaign(id: $id) {
      id
      name
      active
      settings {
        funnelType
        offer {
          ${offerSchema}
        }
        offer_B {
          ${offerSchema}
        }
        offer_testing
        offer_testStatus

        upsell { 
          ${offerSchema}
        }
        upsell_B {
          ${offerSchema}
        }
        upsell_testing
        upsell_testStatus

        downsell {
          ${offerSchema}
        }
        downsell_B {
          ${offerSchema}
        }
        downsell_testing
        downsell_testStatus

        advandced_goals {
          isActive
          cart_value {
            isActive
            target
            relatively
          }
          quantity {
            isActive
            target
            relatively
          }
        }
      }
      target {
        type
        selected {
          id
          image
          title
          handle
        }
        ids
        countries {
          include_active
          include
          exclude_active
          exclude
        }
      }
    }
  }
`;

export default GET_SINGLE_CAMPAIGN;
